import {Button, Modal, Typography} from 'antd';
import {
  useCreateMasterAccountApiKeyMutation,
  useDeleteMasterAccountApiKeyMutation,
  useUserMasterAccountQuery
} from 'api/generated';
import {AnchorLink} from 'components';
import {formatApiKey} from 'lib/formaters';
import {omitEmpty} from 'lib/omitEmpty';
import React, {useState} from 'react';

const {Text, Paragraph} = Typography;

export const ApiSettings: React.FC = () => {
  const [isOpen, setOpen] = useState(false);
  const [isApiKeyVisible, setIsApiKeyVisible] = useState(false);

  const {data, loading} = useUserMasterAccountQuery();
  const account = data?.userMasterAccount;

  const [createApiKey, {loading: isCreating}] = useCreateMasterAccountApiKeyMutation();
  const [deleteApiKey, {loading: isDeleting}] = useDeleteMasterAccountApiKeyMutation();

  if (!account && loading) return null;

  const handleCreate = async () => {
    if (!account) return;

    await createApiKey({
      variables: omitEmpty({
        input: {
          masterAccountId: account.id,
          apiKey: account.apiKey,
          livemode: !account.test || false
        }
      })
    });
  };

  const handleDelete = async () => {
    if (!account) return;
    await deleteApiKey({
      variables: {input: {masterAccountId: account.id, apiKey: account.apiKey}}
    });
    setOpen(false);
  };

  const toggleApiKeyVisibility = () => {
    setIsApiKeyVisible(!isApiKeyVisible);
  };

  return (
    <>
      <h2>API Access</h2>
      <dl>
        <dt>Documentation</dt>
        <dd>
          Find out how to integrate MONEI in our{' '}
          <AnchorLink href="https://docs.monei.com/monei-connect/#integration" target="_blank">
            API Documentation
          </AnchorLink>
          .
        </dd>
        <dt>Your Master Account ID</dt>
        <dd>
          <Text copyable code>
            {account?.id}
          </Text>
        </dd>
        {account?.apiKey && (
          <>
            <dt>Your API Key</dt>
            <dd>
              <Text copyable={{text: account.apiKey}} code>
                {isApiKeyVisible ? account.apiKey : formatApiKey(account.apiKey)}
              </Text>{' '}
              <AnchorLink onClick={toggleApiKeyVisibility} style={{cursor: 'pointer'}}>
                {isApiKeyVisible ? 'Hide' : 'Show'}
              </AnchorLink>
            </dd>
          </>
        )}
      </dl>
      <Paragraph>
        {account?.apiKey ? (
          <Button type="primary" danger onClick={() => setOpen(true)}>
            Delete API Key
          </Button>
        ) : (
          <Button type="primary" onClick={handleCreate} loading={isCreating}>
            Create API Key
          </Button>
        )}
      </Paragraph>
      <Modal
        title="Are you sure?"
        open={isOpen}
        onCancel={() => setOpen(false)}
        onOk={handleDelete}
        cancelText="Cancel"
        okText="Delete"
        confirmLoading={isDeleting}
        okType="danger">
        This action will delete your API key. Everyone who uses it will not be able to access API
        anymore.
      </Modal>
    </>
  );
};
